'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  slider: '[data-testimonials]'
};

(0, _themeSections.register)('testimonials', {

  onLoad: function onLoad() {

    var testimonialsSlider = this.container.querySelector(selectors.slider);
    (0, _jquery2.default)(testimonialsSlider).slick({
      dots: true,
      arrows: false,
      swipe: true,
      cssEase: 'linear',
      draggable: false,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 500,
      fade: false
    });
  }

});